/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateAuthRequest } from '../../axios/candidateAuthRequest'
import type {
	CandidateAuthRequestError,
	CandidateAuthRequestRequest,
	CandidateAuthRequestResponse,
} from '../../types/CandidateAuthRequest'

export const candidateAuthRequestMutationKey = () => [{ url: '/candidate-center/login/request' }] as const

export type CandidateAuthRequestMutationKey = ReturnType<typeof candidateAuthRequestMutationKey>

export type CandidateAuthRequestVariables = {
	data: CandidateAuthRequestRequest
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateAuthController.php CandidateAuthController::request */
export function useCandidateAuthRequest<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateAuthRequestResponse,
		AxiosError<CandidateAuthRequestError>,
		CandidateAuthRequestVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateAuthRequestMutationKey(),
		mutationFn: ({ data }: CandidateAuthRequestVariables) =>
			candidateAuthRequest(data, config).then(res => res.data),
		...options,
	})
}
